import React from 'react';
import Header from './../../inc/Header';
import Footer from './../../inc/Footer';
import Loader from './../../inc/Loader';
import Menu from './../../inc/Menu';
import MenuToggleBtn from './../../inc/MenuToggleBtn';

import Hero from './Hero';
import ProjectInfo from './ProjectInfo';
import ProjectInfoModal from './ProjectInfoModal';
import NewLayouts from './NewLayouts';
import VimeoVideo from './VimeoVideo';
import Image from './Image';
import ImageHalf from './ImageHalf';
import Quote from './Quote';


import Carousel from './Carousel';
import DrawingSlider from './DrawingSlider';
import RelatedProjects from './RelatedProjects';

import ScrollToTop from './../../inc/ScrollToTop';

import { fetchMenu } from "./../../../actions/menuActionCreators";
import { fetchPage } from "./../../../actions/pageActionCreators";
import { fetchOptions } from "./../../../actions/optionActionCreators";
import { fetchProjects } from "./../../../actions/projectActionCreators";
import { fetchPosts } from "./../../../actions/postActionCreators";

class Index extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			pageLoading: true
		}
		this.showLoader = this.showLoader.bind(this);
		this.hideLoader = this.hideLoader.bind(this);
	}

	showLoader(){
		this.setState({
			pageLoading: true
		})
	}

	hideLoader(){
		this.setState({
			pageLoading: false
		})
	}

	componentWillMount() {
		let before = performance.now();
		let _this = this;
        Promise.all([
            this.props.dispatch(fetchMenu('menu')),
            this.props.dispatch(fetchProjects()),
            this.props.dispatch(fetchOptions()),
        ]).then(() => {
            let after = performance.now();
			let diff = after-before;
			let media_length = process.env.REACT_APP_ANIMATION_DURATION;
			if(diff < media_length){
				setTimeout(() => {
					_this.setState({
						pageLoading: false
					})
				},(media_length - diff))
			}else{
				_this.setState({
					pageLoading: false
				})
			}
        });
	}

	render() {
		let { menu } = this.props.menu;
        let _this = this;
        let {pageLoading} = this.state;
        let projects = this.props.projects && Object.keys(this.props.projects.data).length ? this.props.projects.data.all : [];
        let details_slug = this.props.match.params.slug;
        let projectList = projects.filter((item) => {
            return item.post_name == details_slug;
        });

        if (projectList[0] === undefined) return [];

        let related_projects_arr = projectList[0].related_projects;
        let related_projects = [];

        if(related_projects_arr && related_projects_arr.length){
            related_projects = projects.filter((item) => {
                return related_projects_arr.indexOf( item.ID ) >= 0;
            });
        }

		let layoutData = projectList[0].layout.map((row, index) => {
			return (
				<div className="fullW" dangerouslySetInnerHTML={{__html:row}} />
			)
		})
		let headerTheme = projectList[0].theme;
		return (
			<React.Fragment>
				{this.state.pageLoading &&
					<Loader />
				} 
				<ScrollToTop />
				<Header {..._this.props} headerTheme={headerTheme} headerPos='absolute'/>
				<MenuToggleBtn {..._this.props} />

				<main className="mole__project-details">
					<Hero {..._this.props} details={projectList[0]}/>
					<ProjectInfo {..._this.props} details={projectList[0]}/>
					{layoutData}
					{/* <NewLayouts /> */}
					<Carousel {..._this.props} details={projectList[0]}/>
					<DrawingSlider {..._this.props} details={projectList[0]}/>
				</main>
				<RelatedProjects {..._this.props} related_projects={related_projects} showLoader={this.showLoader} hideLoader={this.hideLoader} />
				<ProjectInfoModal {..._this.props} details={projectList[0]}/>
				<Footer  {..._this.props} />
				<Menu  {..._this.props} />
			</React.Fragment>
		);
	}
}

export default Index;


// WEBPACK FOOTER //
// ./src/components/Projects/Marmalade/_index.js